import React, { useState, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";

const RichTextEditor = ({ initialContent = "", onContentChange }) => {
  const [content, setContent] = useState(initialContent); // Editor content
  const [showSource, setShowSource] = useState(false); // Toggle source code view
  const quillRef = useRef(null);

  // Handle content change in the editor
  const handleContentChange = (value) => {
    setContent(value);
    onContentChange?.(value); // Send updated content to parent
  };

  // Sync `initialContent` when it changes
  useEffect(() => {
    setContent(initialContent);
  }, [initialContent]);

  // Toggle between editor and source code
  const toggleSourceView = () => setShowSource((prev) => !prev);

  return (
    <div className="max-w-3xl mx-auto mt-8">
      <div className="flex justify-between align-item mb-4">
        <label className="fw-bold text-lg">Description:</label>
        <Link
          onClick={toggleSourceView}
          className="px-4 fs-14 py-2  mb-5  bg-blue-600 hover:bg-blue-700 text-white rounded shadow transition-all"
        >
          {showSource ? "Back to Editor" : "View Source Code"}
        </Link>
      </div>

      {showSource ? (
        <textarea
          value={content}
          onChange={(e) => handleContentChange(e.target.value)}
          className="w-full h-64 p-4 border rounded-lg bg-white text-black shadow-sm outline-none text-base leading-6"
          style={{
            width: "100%",
            height: "200px",
            resize: "vertical",
            fontFamily: "Arial, sans-serif",
            border: "1px solid #ccc",
          }}
        />
      ) : (
        <ReactQuill
          ref={quillRef}
          value={content}
          onChange={handleContentChange}
          theme="snow"
          placeholder="Start writing here..."
          className="mb-4"
          style={{
            height: "200px",
            marginBottom:"25px"
           
          }}
          modules={{
            toolbar: [
              [{ font: [] }, { size: [] }],
              ["bold", "italic", "underline", "strike"],
              [{ color: [] }, { background: [] }],
              [{ script: "sub" }, { script: "super" }],
              [{ header: [1, 2, 3, false] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ align: [] }],
              ["blockquote", "code-block"],
              ["link", "image", "video"],
              ["clean"],
            ],
          }}
          formats={[
            "font",
            "size",
            "bold",
            "italic",
            "underline",
            "strike",
            "color",
            "background",
            "script",
            "header",
            "list",
            "bullet",
            "indent",
            "direction",
            "align",
            "blockquote",
            "code-block",
            "link",
            "image",
            "video",
          ]}
        />
      )}
    </div>
  );
};

export default RichTextEditor;
